import { Component, inject, input, OnInit } from '@angular/core';
import { MenuItemsServiceService } from '../../Services/menu-items.service.service';
import { SingleMenuItem } from '../../models/Customer Order model/single-menu-item.model';
import { LanguageService } from '../../Services/language.service';
import { OrderService } from '../../Services/order.service';
import { OrderModel } from '../../models/Customer Order model/order-model.model';

@Component({
  selector: 'app-cart-card',
  templateUrl: './cart-card.component.html',
  styleUrl: './cart-card.component.scss',
})
export class CartCardComponent implements OnInit {
  ItemId = input.required<number>();
  order = input.required<OrderModel>();
  amount = 0;

  MenuItemService = inject(MenuItemsServiceService);
  private languageService = inject(LanguageService);
  private orderService = inject(OrderService);

  MenuItem!: SingleMenuItem;
  menuItemName!: string;
  menuItemPrice!: number;
  price?: number;

  ngOnInit(): void {
    this.orderService.orders$.subscribe((orders) => {
      this.amount = this.order().amount;
    });

    this.MenuItemService.getMenuItem(this.ItemId()).subscribe({
      next: (response) => {
        this.MenuItem = response;
        this.loadData();
        this.getPrice();
      },
    });
  }

  loadData() {
    this.orderService.orders$.subscribe((orders) => {
      this.amount = this.order().amount;
      this.languageService.currentLanguage$.subscribe((language) => {
        switch (language) {
          case 'En':
            this.menuItemName = this.MenuItem.nameEn;
            this.menuItemPrice = this.getPrice()! * this.amount;
            break;
          case 'Tr':
            this.menuItemName = this.MenuItem.nameTr;
            this.menuItemPrice = this.getPrice()!  * this.amount;

            break;
          case 'Ar':
            this.menuItemName = this.MenuItem.nameAr;
            this.menuItemPrice = this.getPrice()!  * this.amount;

            break;
          default:
            this.menuItemName = this.MenuItem.nameTr; // Fallback
            this.menuItemPrice = this.getPrice()!  * this.amount;
        }
      });
    });
  }

  getPrice() {
    let order = this.orderService.getOrder(this.MenuItem.id);
    if (order?.isCouponApplied) {
      return order.discountedPrice;
    }
    else {
      return order?.price;
    }
  }
}
